import React from 'react';

interface ToggleOption {
  id: string;
  label: string;
}

interface ToggleButtonGroupProps {
  label: string;
  options: readonly ToggleOption[];
  value: string;
  onChange: (value: string) => void;
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  label,
  options,
  value,
  onChange,
}) => {
  return (
    <div className="flex-1">
      <span className="text-2xs font-medium text-neutral-400 uppercase tracking-wide">{label}</span>
      <div className="flex mt-1.5 gap-1">
        {options.map(option => (
          <button
            type="button"
            key={option.id}
            onClick={() => onChange(option.id)}
            aria-pressed={value === option.id}
            className={`flex-1 py-1.5 text-2xs font-medium rounded-md transition-all border ${
              value === option.id
                ? 'bg-neutral-900 text-white border-neutral-900'
                : 'bg-white text-neutral-600 border-neutral-200 hover:border-neutral-300 hover:bg-neutral-50'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
